import { DAYS_OF_WEEK } from "./types";

/**
 * Format an "HH:mm" 24h time string as 12-hour with am/pm.
 *   "16:00" → "4:00 PM"
 *   "9:30"  → "9:30 AM"
 *   "00:15" → "12:15 AM"
 * Returns the input unchanged when it isn't parseable.
 */
export function formatTime12h(hhmm) {
    if (!hhmm || typeof hhmm !== "string") return hhmm || "";
    const m = hhmm.match(/^(\d{1,2}):(\d{2})$/);
    if (!m) return hhmm;
    let h = parseInt(m[1], 10);
    const mm = m[2];
    if (Number.isNaN(h) || h < 0 || h > 23) return hhmm;
    const period = h >= 12 ? "PM" : "AM";
    h = h % 12;
    if (h === 0) h = 12;
    return `${h}:${mm} ${period}`;
}

export function todayDay() {
    // Monday-first to match DAYS_OF_WEEK
    const jsIdx = new Date().getDay(); // 0=Sun..6=Sat
    const map = [6, 0, 1, 2, 3, 4, 5]; // Sun->6(Sunday),Mon->0,...
    return DAYS_OF_WEEK[map[jsIdx]];
}

export function getTodaysStudents(students, day = todayDay()) {
    return students
        .filter((s) => Array.isArray(s.days) && s.days.includes(day))
        .map((s) => ({
            student: s,
            time: s.schedule?.[day] || "",
        }))
        .sort((a, b) => {
            // Empty times sort last; otherwise lexicographic on "HH:mm" works
            if (!a.time && !b.time) return a.student.name.localeCompare(b.student.name);
            if (!a.time) return 1;
            if (!b.time) return -1;
            return a.time.localeCompare(b.time);
        });
}
